<div id="no-online-booking">
  <img
    src="https://salonmonster.com/images/online-booking.png"
    class="no-online-booking-image"
  />
  <h2>Online booking is not currently available.</h2>
  <h3 *ngIf="salonPhone">Please contact us at {{ salonPhone }}</h3>
</div>
